<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') || '客户名称/方案名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="175px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_search_evgPlanOrderStatus') || '状态'"
            >
              <el-checkbox-group v-model="form.listEvgPlanOrderStatus">
                <el-checkbox label="N">{{
                  $l('form_label_evgPlanOrderStatus_N') || '草稿'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('form_label_evgPlanOrderStatus_Y') || '已确认'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('form_label_evgPlanOrderStatus_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgPlanOrderNo') || '备货计划编号'"
            >
              <el-input
                v-model.trim="form.evgPlanOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_evgPlanOrderName') || '备货计划名称'"
            >
              <el-input
                v-model.trim="form.evgPlanOrderName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_merchandiserCode') || '跟单人员'"
            >
              <dict-select
                v-model="form.listMerchandiserCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_ftyPersonCode') || '工厂跟单人员'"
            >
              <dict-select
                v-model="form.listFtyPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custCode') || '客户'">
              <dict-select
                v-model="form.custCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_platformCode') || '渠道'"
              prop="platformCode"
            >
              <dict-select
                v-model="form.platformCode"
                url="/ecom/evg/platform/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_regionCode') || '运抵国'"
              prop="regionCode"
            >
              <dict-select
                v-model="form.regionCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'region' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_dispatchPort') || '出运港口'"
              prop="dispatchPort"
            >
              <dict-select
                clearable
                filterable
                v-model="form.dispatchPort"
                url="/master/port/select"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_planOrderDate') || '计划日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginPlanOrderDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endPlanOrderDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_beginDeliveryDate') || '计划最早交期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginBeginDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endBeginDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_endDeliveryDate') || '计划最晚交期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginEndDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endEndDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginCreateDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="endCreateDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginModifyDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="endModifyDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listEvgPlanOrderStatus: ['N', 'Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      //创建日期限制
      beginCreateDatePicker: this.endCreateDate(),
      endCreateDatePicker: this.beginCreateDate(),
      //修改日期限制
      beginModifyDatePicker: this.endModifyDate(),
      endModifyDatePicker: this.beginModifyDate(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 创建日期限制
    endCreateDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginCreateDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    endModifyDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginModifyDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
